module.exports = __webpack_public_path__ + "img/download.21b8fafb.svg";